import React from 'react';
import { APITypes } from '../../../../../primary-record-types';
import { useMedicalProfileFileImage } from '../../../../../hooks/api/useMedicalProfileFileImage';
import SizedView from '../../../../v2BaseComponents/SizedView';
import SnippetDisplay from '../../../../shared/FileDisplay/SnippetDisplay';
import BoundingBoxDisplay from '../../../../shared/FileDisplay/BoundingBoxDisplay';
import { getSearchResultDisplayBoundingBoxes } from '../../../../shared/FileDisplay/utils';
import Stack from '../../../../v2BaseComponents/Stack';
import PageDisplay from '../../../../shared/FileDisplay/PageDisplay';

export type SearchResultImageDisplayOwnProps = {
    imageSearchResult: APITypes.medicalProfileFilesService.MedicalProfileFileImageSearchItem;
    medicalProfileId: string;
    showDetailedResult: boolean;
};

export type SearchResultImageDisplayProps = SearchResultImageDisplayOwnProps;

const SearchResultImageDisplay: React.FC<SearchResultImageDisplayProps> = (props) => {
    const medicalProfileFileImage = useMedicalProfileFileImage({
        medicalProfileId: props.medicalProfileId,
        medicalProfileFileId: props.imageSearchResult.medicalProfileFileId,
        page: props.imageSearchResult.page,
    });

    if (medicalProfileFileImage.status !== 'loaded' || !props.showDetailedResult) return null;

    const { overlayBoundingBox, snippetBoundingBox } = props.imageSearchResult.boundingBox
        ? getSearchResultDisplayBoundingBoxes(props.imageSearchResult.boundingBox)
        : { overlayBoundingBox: undefined, snippetBoundingBox: undefined };

    return (
        <SizedView
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-start',
            }}
            testID="sized-view-container"
        >
            {({ width }) => {
                return (
                    <Stack horizontal fullWidth justify="center">
                        {overlayBoundingBox && snippetBoundingBox ? (
                            <BoundingBoxDisplay
                                boundingBox={overlayBoundingBox}
                                rotation={medicalProfileFileImage.image.rotation}
                                imageType={medicalProfileFileImage.image.type}
                            >
                                <SnippetDisplay
                                    fileUrl={medicalProfileFileImage.image.downloadUrl}
                                    containerDimensions={{ width, maxHeight: 500 }}
                                    pageDimensions={medicalProfileFileImage.image.dimensions}
                                    boundingBox={snippetBoundingBox}
                                    type={medicalProfileFileImage.image.type}
                                    rotation={medicalProfileFileImage.image.rotation}
                                />
                            </BoundingBoxDisplay>
                        ) : (
                            <PageDisplay
                                fileUrl={medicalProfileFileImage.image.downloadUrl}
                                containerDimensions={{ width }}
                                pageDimensions={medicalProfileFileImage.image.dimensions}
                                type={medicalProfileFileImage.image.type}
                                rotation={medicalProfileFileImage.image.rotation}
                            />
                        )}
                    </Stack>
                );
            }}
        </SizedView>
    );
};

export default React.memo(SearchResultImageDisplay);
